<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1 class="titlePage titlePage_textLeft">{{getUserName}}</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h2 class="titlePage_subtitle titlePage ">Product Summary</h2>

        <div class="row align-items-start">

          <div class="col-12" v-if="!items.locations">
            <p class="text text_italic text_green">No location added yet</p>
          </div>

          <div class="col-md-4 col-sm-6 col-12"
               v-for="(item, index) in locationListCreate()"
               :key="index">
            <div class="orderItem">

              <div class="orderItem__listItems">
                <h3 class="orderItem__listTitle text_green text_center">{{item.name}}</h3>

                <div class="toggleList"
                     v-for="(elem, key) in item.items.standard"
                     :key="key">
                  <img :src="elem.icon"
                       :alt="elem.name"
                       class="orderItem__img">
                  <h5 class="toggleList__title"
                      :class="{'toggleList__title_empty': items.status.code !== 'DRFT'}"
                  >
                    <span v-if="elem.custom" class="text_red text_bold">Custom</span>
                    <span v-else>{{elem.width}} x {{elem.drop}}</span>
                    {{elem.name}} - {{elem.colour_name}}
                    <span v-if="elem.custom" class="text_red"> - *Call for a quote</span>
                    <span class="text_green toggleList__trigger"
                          v-if="counter(elem.accessories)"
                          @click="openAccessories($event)">
                        +{{counter(elem.accessories)}} accessories
                      </span>
                  </h5>

                  <ul class="toggleList__wrap">
                    <li class="toggleList__item"
                        v-for="accessory in elem.accessories">{{accessory.name}}
                    </li>
                  </ul>
                  <p class="toggleList__price text_green"
                     :class="{'text_red': elem.is_incomplete}"
                  >${{calcPrice(Number(elem.amount).toFixed(2))}}</p>
                </div>

                <div class="orderItem__price"
                   :class="{'text_red': item.is_incomplete}"
                >${{calcPrice(Number(item.amount).toFixed(2))}}</div>
              </div>
              <div class="orderItem__divider" v-if="item.items.custom"></div>
              <div class="orderItem__listItems" v-if="item.items.custom">

                <h3 class="orderItem__listTitle text_red text_center">Custom</h3>

                <div class="toggleList"
                     v-for="(elem, key) in item.items.custom"
                     :key="key">

                  <img :src="elem.icon"
                       :alt="elem.name"
                       class="orderItem__img">
                  <h5 class="toggleList__title">
                    <span v-if="elem.custom" class="text_red text_bold">Custom</span>
                    <span v-else>{{elem.width}} x {{elem.drop}}</span>
                    {{elem.name}}
                    <span v-if="elem.custom" class="text_red"> - *Call for a quote</span>
                    <span class="text_green toggleList__trigger"
                          v-if="counter(elem.accessories)">
                        +{{counter(elem.accessories)}} accessories
                      </span>
                  </h5>

                  <ul class="toggleList__wrap">
                    <li class="toggleList__item"
                        v-for="accessory in elem.accessories">{{accessory.name}}
                    </li>
                  </ul>
                </div>

                <div class="orderItem__price">
                  <span class="text_red text_bold">Call for a quote</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-sm-6 col-12"
               v-for="(item, key, index) in addAccessoryListCreate()"
               :key="key+index">
            <div class="orderItem">
              <div class="orderItem__listItems">
                <h3 class="orderItem__listTitle text_green text_center">{{item.name}}</h3>

                <div class="accessories_list__wrapper">

                  <div class="toggleList toggleList_open"
                       v-for="(elem, key) in shownAccessories(item.items)"
                       :key="key">

                    <ul class="toggleList__wrap">
                      <li class="toggleList__item toggleList__title"
                          v-for="(accessory, accKey) in elem.accessories"
                          :class="{'toggleList__title_empty': code !== 'DRFT'  && code !== 'REVW'}"
                      >
                         <span>
                            {{accessory.name}}
                          </span>

                      </li>
                    </ul>
                  </div>
                </div>

                <div class="orderItem__price" v-if="item.items.standard">
                  aud $0
                </div>
              </div>

              <div class="orderItem__footer" v-if="code === 'DRFT' || code === 'REVW'">
                <button class="btn_link" type="button"
                        @click="addAdditionalAccessories(items, item)">
                  <font-awesome-icon icon="plus"/>
                  Add Additional Accessory
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <order-summary/>
    </div>


    <div class="row" v-if="reasonActions">
      <div class="col-md-8 col-lg-6 col">
        <form class="form" @submit.prevent="submitReason">
          <label class="form__label">
            <span class="form__labelTitle text_bold" v-if="action.toLowerCase() == 'review'">Please put your comments below</span>
            <span class="form__labelTitle text_bold" v-else>Reason to {{action.toUpperCase()}}</span>
            <textarea :name="`reason ${action}` "
                      class="form__input"
                      v-model="reason"
                      v-validate="'required'"
            ></textarea>
            <span class="form__error">{{ errors.first(`reason ${action}`) }}</span>
          </label>

          <button type="submit" class="btn btn_default">Submit</button>
        </form>
      </div>
    </div>

    <div class="row" v-if="status">
      <div class="col">
        <p class="text text_green text_bold">Order successfully approved!</p>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import router from "../../router";
  import {changePriceForm} from '../../helpers/aroundPrice';

  export default {
    name: "ActionsOrder",

    components: {
      OrderSummary: () => import("./orderSummaryTable/OrderSummary"),
    },

    data() {
      return {
        exchangeData: '',
        currentRouteName: '',
        accessoriesListCount: '',
        editAccessoryData: '',
        editAccessory: false,

        reason: '',
      }
    },

    methods: {
      setRoute() {
        this.currentRouteName = this.$router.currentRoute.name;
      },

        calcPrice(price) {return changePriceForm(price);},

      openAccessories(e) {
        let target = e.target;
        if (target.closest('.accessories_count')) {
          let items = target.closest('.accessories_count').querySelectorAll('.additional__wrap');
          for (let i = 0; i < items.length; i++) {
            items[i].classList.toggle('toggleList_open');
            items[i].classList.toggle('additional__wrap_open');
          }
        }
        else {
          target.closest('.toggleList').classList.toggle('toggleList_open');
        }
      },

      counter(elem) {
        if (!elem) {
          return false;
        }
        return _.toInteger(Object.keys(elem).length);
      },

      locationListCreate() {
        if (!this.items.locations) return;
        return _.filter(this.items.locations, function (location) {
          if (location.name !== "Accessories") return location
        });
      },

      addAccessoryListCreate() {
        if (!this.items.locations)
          return;

        return _.filter(this.items.locations, function (location) {
          if (location.name === "Accessories") return location
        });
      },

      shownAccessories: function (items) {

        let itemsObj = {};

        if (items.standard) {
          itemsObj = items.standard;
        } else if (items.custom) {
          itemsObj = items.custom;
        }
        return itemsObj;
      },


      checkCustom(elem) {
        let custom = false;
        for (let k in elem.items) {
          if (k === 'custom') {
            return custom = true;
          }
        }
      },

      submitReason() {
        this.$validator.validate().then(valid => {
          if (valid) {
            if (this.action === 'reject') {
              this.$store.dispatch('orderPreview/rejectOrder', this.reason);
            }

            if (this.action === 'review') {
              this.$store.dispatch('orderPreview/reviewOrder', this.reason);
            }
          }
        });
      }
    },

    computed: {
      ...mapGetters({
        items: 'orderPreview/items',
        action: 'orderPreview/action',
        status: 'orderPreview/status',
      }),

      getUserName() {
        return localStorage.getItem('nameUser');
      },

      reasonActions() {
        if (this.action === 'reject' || this.action === 'review') {
          return true;
        }
        else return false;
      }
    },

    created() {
      this.setRoute();
      this.$store.commit('orderPreview/id', this.$route.query.order_id);
      this.$store.commit('orderPreview/action', this.$route.query.action);
      this.$store.commit('orderPreview/key', this.$route.query.key);

      this.$store.dispatch('orderPreview/getPreviewGuest', this.$route);

    },

    mounted() {
      if (this.action === 'approve') {
        this.$store.dispatch('orderPreview/approveOrder');
      }
      else {
        this.$store.commit('orderPreview/status', false);
      }
    }
  }
</script>

<style scoped>

</style>
